import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation AddAssetToCase($companyId: ID!, $attributes: AssetAssetCaseAttributes!, $id: ID!) {
    addAssetToCase(companyId: $companyId, attributes: $attributes, id: $id) {
      assetCase {
        id
        assets { 
          id
        }
      }
      errors {
        path
        message
      }
    }
  }
`
